import { useIsMobileSize } from 'hooks';
import { Table, TableMobile } from 'libs/ui';

import { useColumns } from './columns';
import { useMobileColumns } from './columnsMobile';
import { DocumentsListItem } from './types';

export interface DocumentsTableProps {
  documents: DocumentsListItem[];
  onClickDownload: (id: DocumentsListItem) => void;
  onClickPreview: (id: DocumentsListItem) => void;
}

export const DocumentsTable = ({
  documents,
  onClickDownload,
  onClickPreview,
}: DocumentsTableProps) => {
  const columns = useColumns({ onClickDownload, onClickPreview });
  const columnsMobile = useMobileColumns({ onClickDownload, onClickPreview });

  const isMobile = useIsMobileSize();

  return isMobile ? (
    <TableMobile columns={columnsMobile} rows={documents} />
  ) : (
    <Table
      columns={columns}
      rowHeight={62}
      rows={documents}
      styleVariant="outline"
    />
  );
};
